module.exports = new __parcel__URL__("floor-tom_11.58d9143f.mp3").toString();